module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.isAuthenticated) ? _c('div', {
    staticClass: "ui vertical menu",
    attrs: {
      "id": "menuLeft"
    }
  }, [_vm._m(0), _vm._v(" "), _c('customer', {
    ref: "customer"
  }, [_c('a', {
    staticClass: "ui button small green btn_customer",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('i', {
    staticClass: "user circle icon"
  }), _vm._v(" " + _vm._s(_vm.$t('Search / Add customer')) + "\n      ")])]), _vm._v(" "), (_vm.currentCustomer) ? _c('a', {
    staticClass: "ui button small green btn_customer",
    on: {
      "click": function($event) {
        return _vm.redirectToHome()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Back to home')) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.customers), function(customer, index) {
    return _c('a', {
      key: index,
      class: [
        _vm.currentCustomer && _vm.currentCustomer.id == customer.id ?
        'item customer active' :
        'item customer'
      ],
      on: {
        "click": function($event) {
          return _vm.loadCustomer(customer)
        }
      }
    }, [_c('div', {
      staticClass: "content user-card"
    }, [_c('a', {
      staticClass: "header"
    }, [_vm._v(_vm._s(customer.firstname + ' ' + customer.lastname))]), _vm._v(" "), _c('div', {
      staticClass: "extra"
    }, [_c('div', {
      staticClass: "ui label"
    }, [_c('i', {
      staticClass: "cart icon"
    }), _vm._v(" "), (customer.cart && customer.cart.products) ? _c('span', [_vm._v(_vm._s(customer.cart.products.length) + " shirt(s)")]) : _c('span', [_vm._v("Error")])]), _vm._v(" "), (_vm.getTotalPrice(customer) > 0) ? _c('a', {
      staticClass: "ui tag label"
    }, [_vm._v(_vm._s(_vm._f("price")(_vm.getTotalPrice(customer))) + " ")]) : _vm._e()])])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.isAuthenticated) ? _c('div', {
    staticClass: "menu-content"
  }, [_c('router-view')], 1) : _vm._e(), _vm._v(" "), (!_vm.isAuthenticated) ? _c('authentication') : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "loader"
  }, [_c('i', {
    staticClass: "loading spinner icon"
  })]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item btn_home"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/top-logo.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd26cd6c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 508
// module chunks = 1